export const Steps = Object.freeze({
  confirmation: "confirmation",
  identification: "identification",
  registration: "registration",
});
